// // import React, { useState, useEffect, useCallback } from "react";
// // import {
// //   Box,
// //   Typography,
// //   TextField,
// //   Button,
// //   Chip,
// //   Checkbox,
// //   FormControlLabel,
// //   Switch,
// //   InputAdornment,
// //   Snackbar,
// //   Alert,
// //   Divider,
// //   Stack,
// //   CircularProgress,
// // } from "@mui/material";
// // import {
// //   Add as AddIcon,
// //   FilterList as FilterIcon,
// //   FilterAlt as FilterAltIcon,
// // } from "@mui/icons-material";
// // import CustomIcon from "../../components/CustomIcon";
// // import StyledDataGrid from "../../components/StyledDataGrid";
// // import PageHeader from "../../components/PageHeader";
// // import SearchBar from "../../components/SearchBar";
// // import AddUserForm from "../../components/AddUserForm";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { fetchUserManagementData } from "../../utils/api";
// // import { formatDate } from "../../utils/formatDateTime";
// // import { Refresh as RefreshIcon } from "@mui/icons-material";
// // import { getStatusChipStyle, BASE_CHIP_SX } from "../../constants/statusColors";

// // const maroon = "#500000";

// // const UserManagement = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const [users, setUsers] = useState([]);
// //   const [totalUsers, setTotalUsers] = useState(0);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [activeFilter, setActiveFilter] = useState(false);
// //   const [inactiveFilter, setInactiveFilter] = useState(false);
// //   const [deactivatedFilter, setDeactivatedFilter] = useState(false);
// //   const [superAdminFilter, setSuperAdminFilter] = useState(false);
// //   const [systemManagerFilter, setSystemManagerFilter] = useState(false);
// //   const [bioBankCoordinatorFilter, setBioBankCoordinatorFilter] =
// //     useState(false);
// //   const [clinicCoordinatorFilter, setClinicCoordinatorFilter] = useState(false);
// //   const [sampleTechnicianFilter, setSampleTechnicianFilter] = useState(false);
// //   const [regulatoryTeamFilter, setRegulatoryTeamFilter] = useState(false);
// //   const [viewerOperationsFilter, setViewerOperationsFilter] = useState(false);
// //   const [showDeactivatedAccounts, setShowDeactivatedAccounts] = useState(false);
// //   const [selectedUsers, setSelectedUsers] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [successMessage, setSuccessMessage] = useState("");
// //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// //   const [addUserModalOpen, setAddUserModalOpen] = useState(false);

// //   // Fetch users from API
// //   const fetchUsers = useCallback(async () => {
// //     setLoading(true);
// //     setError(null);

// //     try {
// //       // Build filter parameters
// //       const statusFilter = [];
// //       if (activeFilter) statusFilter.push("Active");
// //       if (inactiveFilter) statusFilter.push("Inactive");
// //       if (deactivatedFilter) statusFilter.push("Deactivated");

// //       const roleFilter = [];
// //       if (superAdminFilter) roleFilter.push("Super Admin");
// //       if (systemManagerFilter) roleFilter.push("System Manager");
// //       if (bioBankCoordinatorFilter) roleFilter.push("BioBank Coordinator");
// //       if (clinicCoordinatorFilter) roleFilter.push("Clinic Coordinator");
// //       if (sampleTechnicianFilter) roleFilter.push("Sample Technician");
// //       if (regulatoryTeamFilter) roleFilter.push("Regulatory Team");
// //       if (viewerOperationsFilter) roleFilter.push("Viewer: Operations");

// //       const params = {
// //         search: searchTerm,
// //         status: statusFilter,
// //         roles: roleFilter,
// //         showDeactivated: showDeactivatedAccounts,
// //         sortBy: "lastName",
// //         sortOrder: "asc",
// //       };

// //       const response = await fetchUserManagementData(params);

// //       if (response && response.users) {
// //         // Transform API data to match our expected format
// //         const transformedUsers = response.users.map((user, index) => ({
// //           id: user.userId || user.id || index + 1,
// //           name:
// //             user.name ||
// //             `${user.firstName || ""} ${user.lastName || ""}`.trim() ||
// //             "User Name",
// //           userRole:
// //             Array.isArray(user.userRoles) && user.userRoles.length > 0
// //               ? user.userRoles.join(", ")
// //               : user.userRole || user.role || "User",
// //           email: user.email || `UserName${index + 1}@gmail.com`,
// //           lastActive: user.lastActive ? formatDate(user.lastActive) : formatDate(new Date()),
// //           status: user.status || user.accountStatus || "Active",
// //         }));

// //         setUsers(transformedUsers);
// //         setTotalUsers(response.total || transformedUsers.length);
// //       } else {
// //         setUsers([]);
// //         setTotalUsers(0);
// //       }
// //     } catch (err) {
// //       console.error("Error fetching users:", err);
// //       setError("Failed to load users. Please try again.");
// //       setUsers([]);
// //       setTotalUsers(0);
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [
// //     searchTerm,
// //     activeFilter,
// //     inactiveFilter,
// //     deactivatedFilter,
// //     superAdminFilter,
// //     systemManagerFilter,
// //     bioBankCoordinatorFilter,
// //     clinicCoordinatorFilter,
// //     sampleTechnicianFilter,
// //     regulatoryTeamFilter,
// //     viewerOperationsFilter,
// //     showDeactivatedAccounts,
// //   ]);

// //   // Fetch users on component mount
// //   useEffect(() => {
// //     fetchUsers();
// //   }, [fetchUsers]);

// //   // Debounced search effect
// //   useEffect(() => {
// //     const timeoutId = setTimeout(() => {
// //       fetchUsers();
// //     }, 500); // 500ms debounce

// //     return () => clearTimeout(timeoutId);
// //   }, [searchTerm, fetchUsers]);

// //   // Handle success message from navigation state
// //   useEffect(() => {
// //     if (location.state?.successMessage) {
// //       setSuccessMessage(location.state.successMessage);
// //       setSnackbarOpen(true);
// //       // Clear the state to prevent showing the message again
// //       window.history.replaceState({}, document.title);
// //     }
// //   }, [location.state]);

// //   // Handle search input change
// //   const handleSearchChange = (event) => {
// //     setSearchTerm(event.target.value);
// //   };

// //   // Handle clear filters
// //   const handleClearFilters = () => {
// //     setActiveFilter(false);
// //     setInactiveFilter(false);
// //     setDeactivatedFilter(false);
// //     setSuperAdminFilter(false);
// //     setSystemManagerFilter(false);
// //     setBioBankCoordinatorFilter(false);
// //     setClinicCoordinatorFilter(false);
// //     setSampleTechnicianFilter(false);
// //     setRegulatoryTeamFilter(false);
// //     setViewerOperationsFilter(false);
// //     setShowDeactivatedAccounts(false);
// //     setSearchTerm("");
// //   };

// //   // Handle add new user
// //   const handleAddNewUser = () => {
// //     setAddUserModalOpen(true);
// //   };

// //   // Handle add user modal close
// //   const handleAddUserClose = () => {
// //     setAddUserModalOpen(false);
// //   };

// //   // Handle add user save
// //   const handleAddUserSave = (userData) => {
// //     // Refresh the users list
// //     fetchUsers();
// //     setSuccessMessage(
// //       `User "${userData.firstName} ${userData.lastName}" has been created successfully!`
// //     );
// //     setSnackbarOpen(true);
// //   };

// //   // Handle row click to navigate to user profile
// //   const handleRowClick = (params) => {
// //     navigate(`/admin/users/profile/${params.row.id}`);
// //   };

// //   // Handle snackbar close
// //   const handleSnackbarClose = (event, reason) => {
// //     if (reason === "clickaway") {
// //       return;
// //     }
// //     setSnackbarOpen(false);
// //   };

// //   // Users are already filtered by the API, so we use them directly
// //   const filteredUsers = users;

// //   // Define columns for the DataGrid
// //   const columns = [
// //     {
// //       field: "name",
// //       headerName: "Name",
// //       flex: 0.75,
// //       minWidth: 150,
// //     },
// //     {
// //       field: "userRole",
// //       headerName: "User Roles",
// //       flex: 0.75,
// //       minWidth: 150,
// //     },
// //     {
// //       field: "email",
// //       headerName: "E-mail",
// //       flex: 1,
// //       minWidth: 220,
// //     },
// //     {
// //       field: "lastActive",
// //       headerName: "Last Active",
// //       flex: 0.5,
// //       minWidth: 120,
// //       sortable: true,
// //     },
// //     {
// //       field: "status",
// //       headerName: "Account Status",
// //       flex: 0.6,
// //       minWidth: 120,
// //       renderCell: (params) => {
// //         return (
// //           <Chip
// //             label={params.value}
// //             size="small"
// //             sx={{
// //               ...BASE_CHIP_SX,
// //               ...getStatusChipStyle(params.value),
// //             }}
// //           />
// //         );
// //       },
// //     },
// //   ];

// //   return (
// //     <Box
// //       sx={{
// //         backgroundColor: "white",
// //         height: "calc(100vh - 96px)",
// //         display: "flex",
// //         flexDirection: "column",
// //         maxWidth: "100vw",
// //         overflowX: "hidden",
// //       }}
// //     >
// //       {/* User Management Header */}
// //       <PageHeader title="User Management" />

// //       {/* Main Content - Two Column Layout */}
// //       <Box sx={{ display: "flex", gap: 2, flex: 1, minHeight: 0 }}>
// //         {/* Left Panel - Filters */}
// //         <Box
// //           sx={{
// //             width: 250,
// //             flexShrink: 0,
// //             backgroundColor: "white",
// //             border: "1px solid #000",
// //             borderRadius: 0,
// //             p: 2,
// //             overflow: "hidden",
// //             display: "flex",
// //             flexDirection: "column",
// //               "& .MuiFormControlLabel-root": {
// //                 margin: 0,
// //               },
// //               "& .MuiFormControlLabel-label": {
// //                 fontSize: "0.875rem",
// //                 lineHeight: 1.5,
// //               },
// //             }}
// //           >
// //             <Box sx={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", pr: 1 }}>
// //             {/* Account Status Filter */}
// //             <Box sx={{ mb: 1.5 }}>
// //               <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
// //                 <FilterAltIcon sx={{ color: maroon, fontSize: 20 }} />
// //                 <Typography sx={{ fontSize: "16px", fontWeight: 600, color: maroon }}>
// //                   Account Status
// //                 </Typography>
// //               </Box>
// //               <Divider sx={{ mb: 1 }} />
// //               <Stack spacing={0.5}>
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={activeFilter}
// //                       onChange={(e) => setActiveFilter(e.target.checked)}
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="Active"
// //                 />
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={inactiveFilter}
// //                       onChange={(e) => setInactiveFilter(e.target.checked)}
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="Inactive"
// //                 />
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={deactivatedFilter}
// //                       onChange={(e) => setDeactivatedFilter(e.target.checked)}
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="Deactivated"
// //                 />
// //               </Stack>
// //             </Box>

// //             {/* User Role Filter */}
// //             <Box sx={{ mb: 1.5 }}>
// //               <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
// //                 <FilterAltIcon sx={{ color: maroon, fontSize: 20 }} />
// //                 <Typography sx={{ fontSize: "16px", fontWeight: 600, color: maroon }}>
// //                   User Role
// //                 </Typography>
// //               </Box>
// //               <Divider sx={{ mb: 1 }} />
// //               <Stack spacing={0.5}>
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={superAdminFilter}
// //                       onChange={(e) => setSuperAdminFilter(e.target.checked)}
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="Super Admin"
// //                 />
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={systemManagerFilter}
// //                       onChange={(e) => setSystemManagerFilter(e.target.checked)}
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="System Manager"
// //                 />
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={bioBankCoordinatorFilter}
// //                       onChange={(e) =>
// //                         setBioBankCoordinatorFilter(e.target.checked)
// //                       }
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="BioBank Coordinator"
// //                 />
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={clinicCoordinatorFilter}
// //                       onChange={(e) =>
// //                         setClinicCoordinatorFilter(e.target.checked)
// //                       }
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="Clinic Coordinator"
// //                 />
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={sampleTechnicianFilter}
// //                       onChange={(e) =>
// //                         setSampleTechnicianFilter(e.target.checked)
// //                       }
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="Sample Technician"
// //                 />
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={regulatoryTeamFilter}
// //                       onChange={(e) =>
// //                         setRegulatoryTeamFilter(e.target.checked)
// //                       }
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="Regulatory Team"
// //                 />
// //                 <FormControlLabel
// //                   control={
// //                     <Checkbox
// //                       checked={viewerOperationsFilter}
// //                       onChange={(e) =>
// //                         setViewerOperationsFilter(e.target.checked)
// //                       }
// //                       sx={{ color: maroon }}
// //                     />
// //                   }
// //                   label="Viewer: Operations"
// //                 />
// //               </Stack>
// //             </Box>

// //             {/* Show Deactivated Accounts Toggle */}
// //             <Box sx={{ mb: 1.5 }}>
// //               <FormControlLabel
// //                 control={
// //                   <Switch
// //                     checked={showDeactivatedAccounts}
// //                     onChange={(e) =>
// //                       setShowDeactivatedAccounts(e.target.checked)
// //                     }
// //                     sx={{
// //                       "& .MuiSwitch-switchBase.Mui-checked": {
// //                         color: maroon,
// //                       },
// //                       "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
// //                         {
// //                           backgroundColor: maroon,
// //                         },
// //                     }}
// //                   />
// //                 }
// //                 label="Deactivated Accounts"
// //               />
// //             </Box>

// //           </Box>

// //             {/* Clear Button */}
// //             <Box sx={{ pt: 2, mt: "auto", borderTop: "1px solid #eee" }}>
// //             <Button
// //               variant="outlined"
// //               startIcon={<RefreshIcon />}
// //               onClick={handleClearFilters}
// //               sx={{
// //                 textTransform: "uppercase",
// //                 borderRadius: 0,
// //                 borderColor: maroon,
// //                 color: maroon,
// //                 width: "100%",
// //                 "&:hover": {
// //                   borderColor: maroon,
// //                   backgroundColor: "rgba(80, 0, 0, 0.06)",
// //                 },
// //               }}
// //             >
// //               CLEAR
// //             </Button>
// //             </Box>
// //           </Box>

// //         {/* Right Panel - Data Grid */}
// //         <Box sx={{ flex: 1, minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column" }}>
// //           {/* Search Box and Add User Button */}
// //           <Box
// //             sx={{
// //               display: "flex",
// //               justifyContent: "space-between",
// //               alignItems: "center",
// //               mb: 2,
// //               width: "100%",
// //               gap: 2,
// //             }}
// //           >
// //             <SearchBar
// //               placeholder="Search User Name..."
// //               value={searchTerm}
// //               onChange={handleSearchChange}
// //               sx={{
// //                 width: { xs: "100%", sm: 300 },
// //                 flex: { xs: 1, sm: "none" }
// //               }}
// //             />

// //             <Button
// //               variant="contained"
// //               size="small"
// //               startIcon={<AddIcon />}
// //               onClick={handleAddNewUser}
// //               sx={{
// //                 backgroundColor: maroon,
// //                 color: "white",
// //                 borderRadius: 0,
// //                 textTransform: "uppercase",
// //                 px: 3,
// //                 py: 1,
// //                 fontWeight: 600,
// //                 height: "40px", // Match TextField height
// //                 "&:hover": {
// //                   backgroundColor: "#400000",
// //                 },
// //               }}
// //             >
// //               ADD NEW USER
// //             </Button>
// //           </Box>

// //           <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
// //             {error ? (
// //               <Box
// //                 sx={{
// //                   display: "flex",
// //                   justifyContent: "center",
// //                   alignItems: "center",
// //                   height: "100%",
// //                   flexDirection: "column",
// //                   gap: 2,
// //                 }}
// //               >
// //                 <Typography color="error" variant="h6">
// //                   {error}
// //                 </Typography>
// //                 <Button
// //                   variant="outlined"
// //                   onClick={fetchUsers}
// //                   sx={{ color: maroon, borderColor: maroon }}
// //                 >
// //                   Retry
// //                 </Button>
// //               </Box>
// //             ) : (
// //               <StyledDataGrid
// //                 sx={{ flex: 1 }}
// //                 rows={filteredUsers}
// //                 columns={columns}
// //                 pageSizeOptions={[10, 25, 50, 100]}
// //                 pagination
// //                 disableSelectionOnClick
// //                 onRowClick={handleRowClick}
// //                 loading={loading}
// //                 initialState={{
// //                   pagination: { paginationModel: { pageSize: 25 } },
// //                 }}
// //               />
// //             )}
// //           </Box>
// //         </Box>
// //       </Box>

// //       {/* Success Snackbar */}
// //       <Snackbar
// //         open={snackbarOpen}
// //         autoHideDuration={5000}
// //         onClose={handleSnackbarClose}
// //         anchorOrigin={{ vertical: "top", horizontal: "center" }}
// //       >
// //         <Alert
// //           onClose={handleSnackbarClose}
// //           severity="success"
// //           sx={{ width: "100%" }}
// //         >
// //           {successMessage}
// //         </Alert>
// //       </Snackbar>

// //       {/* Add User Modal */}
// //       <AddUserForm
// //         open={addUserModalOpen}
// //         onClose={handleAddUserClose}
// //         onSave={handleAddUserSave}
// //       />
// //     </Box>
// //   );
// // };

// // export default UserManagement;

import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Chip,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Snackbar,
  Alert,
  Divider,
  Stack,
  CircularProgress,
} from "@mui/material";
import {
  FilterList as FilterIcon,
  FilterAlt as FilterAltIcon,
  ChevronRight as ChevronRightIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import CustomIcon from "../../components/CustomIcon";
import StyledDataGrid from "../../components/StyledDataGrid";
import PageHeader from "../../components/PageHeader";
import SearchBar from "../../components/SearchBar";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchUserManagementData } from "../../utils/api";
import { formatDate } from "../../utils/formatDateTime";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import { getStatusChipStyle, BASE_CHIP_SX } from "../../constants/statusColors";

const maroon = "#500000";

const ROLE_DISPLAY_LABELS = {
  "System Manager": "Study Manager",
};
const EMPTY_VALUE = "\u2014";

const UserManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [activeFilter, setActiveFilter] = useState(false);
  const [inactiveFilter, setInactiveFilter] = useState(false);
  const [superAdminFilter, setSuperAdminFilter] = useState(false);
  const [systemManagerFilter, setSystemManagerFilter] = useState(false);
  const [bioBankCoordinatorFilter, setBioBankCoordinatorFilter] =
    useState(false);
  const [clinicCoordinatorFilter, setClinicCoordinatorFilter] = useState(false);
  const [sampleTechnicianFilter, setSampleTechnicianFilter] = useState(false);
  const [regulatoryTeamFilter, setRegulatoryTeamFilter] = useState(false);
  const [viewerOperationsFilter, setViewerOperationsFilter] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });

  const requestIdRef = useRef(0);
  const resetToFirstPage = useCallback(() => {
    setPaginationModel((prev) =>
      prev.page === 0 ? prev : { ...prev, page: 0 }
    );
  }, []);
  const handleFilterToggle = useCallback(
    (setter) => (event) => {
      setter(event.target.checked);
      resetToFirstPage();
    },
    [resetToFirstPage]
  );

  // Fetch users from API
  const fetchUsers = useCallback(async () => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    setError(null);

    try {
      // Build filter parameters
      const statusFilter = [];
      if (activeFilter) statusFilter.push("Active");
      if (inactiveFilter) statusFilter.push("Inactive");

      const roleFilter = [];
      if (superAdminFilter) roleFilter.push("Super Admin");
      if (systemManagerFilter) roleFilter.push("System Manager");
      if (bioBankCoordinatorFilter) roleFilter.push("BioBank Coordinator");
      if (clinicCoordinatorFilter) roleFilter.push("Clinic Coordinator");
      if (sampleTechnicianFilter) roleFilter.push("Sample Technician");
      if (regulatoryTeamFilter) roleFilter.push("Regulatory Team");
      if (viewerOperationsFilter) roleFilter.push("Viewer: Operations");

      const params = {
        page: paginationModel.page,
        size: paginationModel.pageSize,
        search: debouncedSearchTerm,
        status: statusFilter,
        roles: roleFilter,
        sortBy: "lastName",
        sortOrder: "asc",
      };

      const response = await fetchUserManagementData(params);

      if (requestId !== requestIdRef.current) return;

      if (response && Array.isArray(response.content)) {
        // Missing values render as an em dash. Never substitute a plausible
        // looking one: the previous fallbacks invented email addresses and
        // showed today's date for users who had never logged in, which read as
        // real data and hid the gap for a long time.
        const transformedUsers = response.content.map((user, index) => ({
          // Not a data fallback, just the render key the DataGrid requires.
          id: user.userId || `${paginationModel.page}-${index + 1}`,
          name:
            `${user.firstName || ""} ${user.lastName || ""}`.trim() || EMPTY_VALUE,
          userRole:
            Array.isArray(user.userRoles) && user.userRoles.length > 0
              ? user.userRoles.map((r) => ROLE_DISPLAY_LABELS[r] || r).join(", ")
              : EMPTY_VALUE,
          email: user.email || EMPTY_VALUE,
          lastActive: user.lastLogin ? formatDate(user.lastLogin) : EMPTY_VALUE,
          status: user.status || EMPTY_VALUE,
        }));

        setUsers(transformedUsers);
        setTotalUsers(
          typeof response.totalElements === "number"
            ? response.totalElements
            : transformedUsers.length
        );
      } else {
        setUsers([]);
        setTotalUsers(0);
      }
    } catch (err) {
      if (requestId !== requestIdRef.current) return;
      console.error("Error fetching users:", err);
      setError("Failed to load users. Please try again.");
      setUsers([]);
      setTotalUsers(0);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  }, [
    debouncedSearchTerm,
    activeFilter,
    inactiveFilter,
    superAdminFilter,
    systemManagerFilter,
    bioBankCoordinatorFilter,
    clinicCoordinatorFilter,
    sampleTechnicianFilter,
    regulatoryTeamFilter,
    viewerOperationsFilter,
    paginationModel.page,
    paginationModel.pageSize,
  ]);

  // Fetch users on component mount
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // Debounce search input before firing server requests
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim());
    }, 500); // 500ms debounce

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  // Handle success message from navigation state
  useEffect(() => {
    if (location.state?.successMessage) {
      setSuccessMessage(location.state.successMessage);
      setSnackbarOpen(true);
      // Clear the state to prevent showing the message again
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    resetToFirstPage();
  };

  // Handle clear filters
  const handleClearFilters = () => {
    setActiveFilter(false);
    setInactiveFilter(false);
    setSuperAdminFilter(false);
    setSystemManagerFilter(false);
    setBioBankCoordinatorFilter(false);
    setClinicCoordinatorFilter(false);
    setSampleTechnicianFilter(false);
    setRegulatoryTeamFilter(false);
    setViewerOperationsFilter(false);
    setSearchTerm("");
    setDebouncedSearchTerm("");
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  // Handle row click to navigate to user profile
  const handleRowClick = (params) => {
    navigate(`/admin/users/profile/${params.row.id}`);
  };

  // Handle snackbar close
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  // Users are already filtered by the API, so we use them directly
  const filteredUsers = users;

  // Define columns for the DataGrid
  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.75,
      minWidth: 150,
    },
    {
      field: "userRole",
      headerName: "User Roles",
      flex: 0.75,
      minWidth: 150,
    },
    {
      field: "email",
      headerName: "E-mail",
      flex: 1,
      minWidth: 220,
    },
    {
      field: "lastActive",
      headerName: "Last Active",
      flex: 0.5,
      minWidth: 120,
      sortable: true,
    },
    {
      field: "status",
      headerName: "Account Status",
      flex: 0.6,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              ...BASE_CHIP_SX,
              ...getStatusChipStyle(params.value),
            }}
          />
        );
      },
    },
    {
      field: "viewProfile",
      headerName: "",
      flex: 0.3,
      minWidth: 56,
      maxWidth: 56,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
      renderCell: () => (
        <Box
          className="row-view-arrow"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            color: maroon,
            opacity: 0.35,
            transform: "translateX(-2px)",
            transition: "opacity 0.15s ease, transform 0.15s ease",
          }}
        >
          <ChevronRightIcon fontSize="small" />
        </Box>
      ),
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "white",
        height: "calc(100vh - 96px)",
        display: "flex",
        flexDirection: "column",
        maxWidth: "100vw",
        overflowX: "hidden",
      }}
    >
      {/* User Management Header */}
      <PageHeader title="User Management" />

      {/* Main Content - Two Column Layout */}
      <Box sx={{ display: "flex", gap: 2, flex: 1, minHeight: 0 }}>
        {/* Left Panel - Filters */}
        <Box
          sx={{
            width: 250,
            flexShrink: 0,
            backgroundColor: "white",
            border: "1px solid #000",
            borderRadius: 0,
            p: 2,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
              "& .MuiFormControlLabel-root": {
                margin: 0,
              },
              "& .MuiFormControlLabel-label": {
                fontSize: "0.875rem",
                lineHeight: 1.5,
              },
            }}
          >
            {/* Search Box */}
            <Box sx={{ mb: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                <SearchIcon sx={{ color: maroon, fontSize: 20 }} />
                <Typography sx={{ fontSize: "16px", fontWeight: 600, color: maroon }}>
                  Search by Name
                </Typography>
              </Box>
              <Divider sx={{ mb: 1 }} />
              <TextField
                placeholder="Enter name..."
                value={searchTerm}
                onChange={handleSearchChange}
                size="small"
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 0,
                  }
                }}
              />
            </Box>

            <Box sx={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", pr: 1 }}>
            {/* Account Status Filter */}
            <Box sx={{ mb: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                <FilterAltIcon sx={{ color: maroon, fontSize: 20 }} />
                <Typography sx={{ fontSize: "16px", fontWeight: 600, color: maroon }}>
                  Account Status
                </Typography>
              </Box>
              <Divider sx={{ mb: 1 }} />
              <Stack spacing={0.5}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={activeFilter}
                      onChange={handleFilterToggle(setActiveFilter)}
                      sx={{ color: maroon }}
                    />
                  }
                  label="Active"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={inactiveFilter}
                      onChange={handleFilterToggle(setInactiveFilter)}
                      sx={{ color: maroon }}
                    />
                  }
                  label="Inactive"
                />
              </Stack>
            </Box>

            {/* User Role Filter */}
            <Box sx={{ mb: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                <FilterAltIcon sx={{ color: maroon, fontSize: 20 }} />
                <Typography sx={{ fontSize: "16px", fontWeight: 600, color: maroon }}>
                  User Role
                </Typography>
              </Box>
              <Divider sx={{ mb: 1 }} />
              <Stack spacing={0.5}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={superAdminFilter}
                      onChange={handleFilterToggle(setSuperAdminFilter)}
                      sx={{ color: maroon }}
                    />
                  }
                  label="Super Admin"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={systemManagerFilter}
                      onChange={handleFilterToggle(setSystemManagerFilter)}
                      sx={{ color: maroon }}
                    />
                  }
                  label="Study Manager"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={bioBankCoordinatorFilter}
                      onChange={handleFilterToggle(setBioBankCoordinatorFilter)}
                      sx={{ color: maroon }}
                    />
                  }
                  label="BioBank Coordinator"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={clinicCoordinatorFilter}
                      onChange={handleFilterToggle(setClinicCoordinatorFilter)}
                      sx={{ color: maroon }}
                    />
                  }
                  label="Clinic Coordinator"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sampleTechnicianFilter}
                      onChange={handleFilterToggle(setSampleTechnicianFilter)}
                      sx={{ color: maroon }}
                    />
                  }
                  label="Sample Technician"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={regulatoryTeamFilter}
                      onChange={handleFilterToggle(setRegulatoryTeamFilter)}
                      sx={{ color: maroon }}
                    />
                  }
                  label="Regulatory Team"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={viewerOperationsFilter}
                      onChange={handleFilterToggle(setViewerOperationsFilter)}
                      sx={{ color: maroon }}
                    />
                  }
                  label="Viewer: Operations"
                />
              </Stack>
            </Box>

          </Box>

            {/* Clear Button */}
            <Box sx={{ pt: 2, mt: "auto", borderTop: "1px solid #eee" }}>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={handleClearFilters}
              sx={{
                textTransform: "uppercase",
                borderRadius: 0,
                borderColor: maroon,
                color: maroon,
                width: "100%",
                "&:hover": {
                  borderColor: maroon,
                  backgroundColor: "rgba(80, 0, 0, 0.06)",
                },
              }}
            >
              CLEAR
            </Button>
            </Box>
          </Box>

        {/* Right Panel - Data Grid */}
        <Box sx={{ flex: 1, minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column" }}>
          <Typography
            variant="caption"
            sx={{ color: "text.secondary", mb: 0.75, display: "block" }}
          >
            Click on a row to view that user's full profile.
          </Typography>

          <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            {error ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Typography color="error" variant="h6">
                  {error}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={fetchUsers}
                  sx={{ color: maroon, borderColor: maroon }}
                >
                  Retry
                </Button>
              </Box>
            ) : (
              <StyledDataGrid
                sx={{
                  flex: 1,
                  "& .MuiDataGrid-row": {
                    cursor: "pointer",
                  },
                  "& .MuiDataGrid-row:hover": {
                    backgroundColor: "rgba(80, 0, 0, 0.06)",
                  },
                  "& .MuiDataGrid-row:hover .row-view-arrow": {
                    opacity: 1,
                    transform: "translateX(0)",
                  },
                  "& .MuiDataGrid-row:focus-within": {
                    backgroundColor: "rgba(80, 0, 0, 0.08)",
                  },
                }}
                rows={filteredUsers}
                columns={columns}
                pageSizeOptions={[10, 25, 50, 100]}
                pagination
                paginationMode="server"
                rowCount={totalUsers}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                disableSelectionOnClick
                onRowClick={handleRowClick}
                loading={loading}
              />
            )}
          </Box>
        </Box>
      </Box>

      {/* Success Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {successMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UserManagement;
